import { computed } from 'vue';
import { useStore } from 'vuex';

export const usePersonalizarPagina = () => {
    const NOME_MODULO_VUEX = 'landingPage';
    const store = useStore();

    const criarCampoComputado = (chave) => {
        return computed({
            get: () => {
                return store.getters[`${NOME_MODULO_VUEX}/obterElementoPorComponente`]('pagina').props[chave] ?? null;
            },
            set: (valor) => {
                store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsPorNome`, { componente: 'pagina', novasProps: { [chave]: valor } });
            },
        });
    };

    const fonte = criarCampoComputado('fonte');
    const pesoFonte = criarCampoComputado('pesoFonte');
    const corFundo = criarCampoComputado('corFundo');
    const imagemFundo = criarCampoComputado('imagemFundo');
    const paddingVertical = criarCampoComputado('paddingVertical');
    const paddingHorizontal = criarCampoComputado('paddingHorizontal');

    const limparFundo = () => {
        imagemFundo.value = null;
        corFundo.value = null;
    };

    return {
        fonte,
        pesoFonte,
        corFundo,
        imagemFundo,
        paddingVertical,
        paddingHorizontal,
        limparFundo,
    };
};
